<template>
    <div class="tm-scope tp-input-screen">
        <div class="tp-input-screen__inner">
            <h1 class="fw-bolder title-1">Search for a Job Title</h1>

            <div class="w-100 my-2 text-start">
                <div class="tp-input-wrap">
                    <input id="inputJob" type="text" placeholder="Input a job title to find the correct version of it!"
                            class="w-100 input-white mt-5" :class="{ 'tp-input--error': hasError }"
                            v-model="job" v-on:keyup.enter="addList()">
                    <FontAwesomeIcon v-if="job" icon="fa-solid fa-circle-plus" class="check-list" @click="addList()"/>
                </div>
                <div class="tp-pill-row">
                    <Pill
                        v-for="(item,i) in jobs" :key="i"
                        :model-value="item" solid
                        @remove="removeList(i)"
                    />
                </div>
            </div>
            <button class="btn-light-blue mt-5" @click="save()">
                <Spinner v-if="spinner" :size="16" />
                <span v-else>Find my Job Title</span>
            </button>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { faClose,faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useRouter } from 'vue-router';
import { UserInfoApiService } from '@/services/UserInfoApiService';
import Pill from '@/components/Pill.vue';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
    components:{FontAwesomeIcon, Pill, Spinner},
    setup() {
        library.add(faClose,faCirclePlus)
        const router = useRouter()
        const job = ref()
        const jobs = ref([])
        const spinner = ref(false)
        const hasError = ref(false)

        function addList() {
            const items = job.value.split(',').map(item => item.trim()).filter(item => item !== '');
            items.forEach(item => {
                jobs.value.push(item);
            })
            job.value = ''
        }

        function removeList(index) {
            const test = ref([])
            for (let i = 0; i < jobs.value.length; i++) {
                if (i!=index) {
                    test.value.push(jobs.value[i])
                }
            }
            jobs.value = test.value
        }

        function save() {
            if (jobs.value.length!=0) {
                hasError.value = false
                spinner.value = true
                UserInfoApiService.saveJobs(jobs.value,localStorage.getItem('user_id')).then((res)=>{
                    if (res.status==200) {
                        localStorage.setItem('occups',1)
                        UserInfoApiService.occups = res.data.processed_occups;
                        spinner.value = false;
                        router.push({name:'view-job'})
                    }
                })
            }
            else {
                hasError.value = true
            }

        }

        return {
            router,
            job,
            jobs,
            spinner,
            hasError,
            removeList,
            save,
            addList
        }
    },
})
</script>
<style scoped>
.tp-input-screen {
    min-height: 100dvh;
    background-color: var(--tm-canvas);
    padding: 10% 24px 48px;
    position: relative;
}

.tp-input-screen__inner {
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
}

.tp-input-wrap {
    position: relative;
}

.tp-pill-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
}

.tp-input--error {
    box-shadow: 0 0 0 2px var(--tm-gap) !important;
}

.check-list{
    position: absolute;
    right: 10px;
    top: 62%;
    font-size: 25px;
    cursor: pointer;
    color: rgb(24, 201, 24);
}
</style>
